import { DateTime } from 'luxon';
import { useMemo, useState } from 'react';
import { useGetFundRates } from '../../../../api/funds-robot/getFundRates';
import { Bond } from '../../../../types/Bond';
import { Stock } from '../../../../types/Stock';
import { downloadCSV, getSelectableYears, ratesAndDividendToNAVCSVString } from '../../../../utils/functions';
import { ModalScreenFunds } from '../../../general/ModalScreen';
import { BNLRates } from '../nav-overlay-tables/BNLRates';
import { OverlayTableHeader } from '../nav-overlay-tables/OverlayTableHeader';

export const BNLRatesModal: React.FC<{ fund: Bond | Stock; isShown: boolean; onClose: () => void }> = ({
    fund,
    isShown,
    onClose,
}) => {
    const [year, setYear] = useState(DateTime.now().year);

    const fundRates = useGetFundRates(fund?.id, DateTime.now(), DateTime.now().minus({ year: 10 }));

    const selectableYears = useMemo(() => {
        return getSelectableYears(fundRates.data);
    }, [fundRates.data]);

    return (
        <ModalScreenFunds isShown={isShown}>
            <div id="nav-modal" className="bg-gray-100">
                <OverlayTableHeader
                    title="NAV dagkoers"
                    selectionYears={selectableYears}
                    onClose={onClose}
                    onExportCSV={() => {
                        downloadCSV(
                            fund.name + ' koersen.csv',
                            ratesAndDividendToNAVCSVString(fundRates.data?.rates || [], fund?.dividendPayments || []),
                        );
                    }}
                    selectedYear={year}
                    onYearSelected={setYear}
                />
                <BNLRates selectedYear={year} />
            </div>
        </ModalScreenFunds>
    );
};
